// app/renderer/ui/rehearsal/section-colors.js
//
// Pure helpers: semantic name → color match + cycle palette fallback.
// No DOM, no I/O. Tested without JSDOM.

import { classifySection } from './section-semantics.js';

export const PALETTE = Object.freeze([
  '#1d4e7a', // navy
  '#1e6e6e', // teal
  '#a87a1f', // gold
  '#5e3a8a', // purple
  '#b85c2c', // orange
  '#3a7a3a', // green
  '#8a3a6e', // magenta
  '#5a5a5a', // grey
]);

// Colour is derived from the semantic type. outro and ending are different
// types (they get different guide-pack phrases) but historically share one
// colour: the map below preserves that, so the existing colour tests stay
// green.
const TYPE_COLORS = Object.freeze({
  'pre-chorus': '#5e3a8a',
  intro: '#1d4e7a',
  verse: '#1e6e6e',
  chorus: '#a87a1f',
  bridge: '#b85c2c',
  instrumental: '#3a7a3a',
  outro: '#5a5a5a',
  ending: '#5a5a5a',
  tag: '#8a3a6e',
});

export function matchSemantic(name) {
  const sem = classifySection(name);
  return sem ? colorForType(sem.type) : null;
}

// Direct type -> colour lookup, exported so callers (and the colour-coverage
// test in section-colors.test.js) can check "every semantic type has a
// colour" without going through name matching.
export function colorForType(type) {
  return TYPE_COLORS[type] ?? null;
}

export function nextCycleColor(usedCount) {
  const i = Math.max(0, Number.isFinite(usedCount) ? usedCount : 0);
  return PALETTE[i % PALETTE.length];
}
